import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./triple-toggle-switch.module.scss";
const TripleToggleSwitch = ({ options, checked, disabled, selectedOption, handleChange, }) => {
    return (_jsxs("div", Object.assign({ className: `${styles.switchWrapper}` }, { children: [_jsx("label", Object.assign({ className: `${styles.labelLeft} ${selectedOption === options[0] ? styles.active : ""}` }, { children: options[0] })), _jsx("div", Object.assign({ className: `${styles.tripleToggleSwitch}`, onClick: (e) => {
                    var _a;
                    let currBtn = Number((_a = e.target) === null || _a === void 0 ? void 0 : _a.value);
                    if (isNaN(currBtn))
                        return;
                    //If clicked btn is same as selected btn, then toggle between 0 and 2
                    if (currBtn === selectedOption) {
                        currBtn = currBtn === 0 ? 2 : 0;
                    }
                    //When clicked on 1 middle btn then toggle between 0 and 2
                    else if (currBtn === 1) {
                        currBtn = selectedOption === 0 ? 2 : 0;
                    }
                    //Else will be same as clicked btn
                    handleChange(currBtn);
                } }, { children: options.map((option, index) => (_jsx("button", { className: `${styles.toggleOption} ${options[selectedOption !== null && selectedOption !== void 0 ? selectedOption : 0] === option ? styles.active : ""}`, value: index }, option))) })), _jsx("label", Object.assign({ className: `${styles.labelRight} ${selectedOption === options[2] ? styles.active : ""}` }, { children: options[2] }))] })));
};
export default TripleToggleSwitch;
